import React from 'react'
import classNames from 'classnames'
import MyCheckmark from './MyCheckmark'
import PropTypes from 'prop-types'

export default function ProductLinePicker(props) {
  return (
    <div className="m-x5 sm-m-x25 hover-up round shadow-1" onClick={props.onSelect} role="img" aria-label={props.label}>
      <img
        src={props.imageSrc}
        alt=""
        className={classNames('full-width', 'animate-500ms', { 'scale-1x1': props.selected })}
      />
      <div
        className={classNames({
          'flex-center fill-all-absolute': true,
          whiten: props.selected
        })}
      >
        <MyCheckmark className={classNames('drop-shadow', { hidden: !props.selected })} style={{ maxWidth: '50%' }} />
      </div>
      <div className="bottom-text center bold">{props.label}</div>
    </div>
  )
}

ProductLinePicker.propTypes = {
  onSelect: PropTypes.func.isRequired,
  imageSrc: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  label: PropTypes.string
}
